import config from 'Config'

export const formatNumber = (num = 0) => {
  return num
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, config.locale === 'de' ? '$1.' : '$1,')
}
